import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqcmb8cn6t: FaireProductEntity = {
  token: "p_gqcmb8cn6t",
  type: "product",
  name: "STRAPLESS NEOPRENE FITTED GOWN",
  brandToken: "b_1udwajl633",
  brandName: "Ladivine by Cinderella Divine",
  imageUrl:
    "https://cdn.faire.com/fastly/3f104d14e3888f6506f776416d732157a0d15616f99b4490b4f36c74d8f0daa1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9eeecc36ec4767f512a9d9a6bbfeffc5c36f5ec85edde810378fce7388df886d.jpeg",
    "https://cdn.faire.com/fastly/47b0c214c962c9b9a011b77592298ba4e3661552e1842ff44e25a2631e2bc20d.jpeg",
    "https://cdn.faire.com/fastly/24406159fc44d77322f241ea064208b3d779edf077cc0e5497d15d7653e20132.jpeg",
    "https://cdn.faire.com/fastly/c6c7f91339f807781e0955e1fc58b6bb83c67a2670687187be6a87abd7eb5334.jpeg",
    "https://cdn.faire.com/fastly/bbb492fa404c6f91f296f02bdb35fad8ba6b7977c137ae0f2d3c2ff4f05da0cc.jpeg",
  ],
  priceDollars: 75.87,
  description:
    "CD355:\nEmbrace elegance with this strapless neoprene dress, featuring a scoop neckline and a structured bodice. The gathered waistline gracefully transitions into cascading layers, creating a whimsical and flattering silhouette. Ideal for bridesmaids or wedding guests, this dress ensures a sophisticated and enchanting look for any special occasion.",
  tags: [],
  msrpDollars: 151.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:35.922Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
